import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {TextField} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {delay} from '@helpers/functions';
import {resetPasswordFromSettings} from '@componentDP/js_react/redux/actions/login';
import {withTranslation} from 'react-i18next';

class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            password_old: '',
            password: '',
            password_confirmation: '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value});
    }

    handleChangePassword() {
        const {password_old, password, password_confirmation} = this.state;
        const {resetPasswordFromSettings, t} = this.props;
        if (password_old && password && password_confirmation) {
            delay(() => {
                const data = {password_old, password, password_confirmation};
                resetPasswordFromSettings(data, t);
            }, 200);
        }
    }

    render() {
        const {handleChange, handleChangePassword} = this;
        const {password_old, password, password_confirmation} = this.state;
        const { t } = this.props
        return (
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h5">
                            {t('change_personal_account_password')}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item md={4}>
                        <TextField
                            type="password"
                            label={t('old_password')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="password_old"
                            value={password_old}
                            onChange={(e) => {handleChange(e)}} />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item md={4}>
                        <TextField
                            type="password"
                            label={t('new_password')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="password"
                            value={password}
                            onChange={(e) => {handleChange(e)}} />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item md={4}>
                        <TextField
                            type="password"
                            label={t('confirm_password')}
                            variant="outlined"
                            fullWidth
                            size="small"
                            name="password_confirmation"
                            value={password_confirmation}
                            onChange={(e) => {handleChange(e)}} />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item md={4}>
                        <Button variant="contained" color="primary" onClick={handleChangePassword}>
                            {t('change_password')}
                        </Button>
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    resetPasswordFromSettings,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ChangePassword));
